<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      items: [
      { sortOrder: 3, title: 'Item 3', description: 'This is the description for item 3.' },
      { sortOrder: 1, title: 'Item 1', description: 'This is the description for item 1.' },
      { sortOrder: 2, title: 'Item 2', description: 'This is the description for item 2.' }
    ]
    }
  }
}
</script>

<style>
* {
  font-family: 'Montserrat', 'sans-serif';
}

</style>